import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
    console.log(`[LoginComponent][ngOnInit] url: ${this.router.url}`);
    const queryParams = this.router.url.split('?')[1];
    const redirectUrl = queryParams && queryParams.length > 1
      ? `/Auth/Dashboard?${queryParams}`
      : '/Auth/Dashboard';
    console.log(`[LoginComponent][ngOnInit] navigate to ${redirectUrl}`);
    this.router.navigateByUrl(redirectUrl);
  }
}
